var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('incidentReports.incidentReportFormLong.trainee')},model:{value:(_vm.value.trainee),callback:function ($$v) {_vm.$set(_vm.value, "trainee", $$v)},expression:"value.trainee"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }